module.exports = require("@nestjs/event-emitter");